import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const User16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 1.25C6.22983 1.25 4.75 2.72983 4.75 4.5C4.75 6.27017 6.22983 7.75 8 7.75C9.77017 7.75 11.25 6.27017 11.25 4.5C11.25 2.72983 9.77017 1.25 8 1.25ZM8 2.75C8.95317 2.75 9.75 3.54683 9.75 4.5C9.75 5.45317 8.95317 6.25 8 6.25C7.04683 6.25 6.25 5.45317 6.25 4.5C6.25 3.54683 7.04683 2.75 8 2.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 13C2.75 11.7574 3.75736 10.75 5 10.75H11C12.2426 10.75 13.25 11.7574 13.25 13V15H14.75V13C14.75 10.9289 13.0711 9.25 11 9.25H5C2.92893 9.25 1.25 10.9289 1.25 13V15H2.75V13Z'
      fill='currentColor'
    />
  </Svg>
);

User16.displayName = 'User16';
export default User16;
